export const defaultContent = {
  home: {
    hero: {
      title: 'Seja Bem-vindo (a)!',
      subtitle: 'Olá, meu nome é Gabriel de Carli, e é um prazer ter você aqui. Neste site, você poderá conhecer mais sobre o meu trabalho e agendar um encontro, seja virtual ou presencial, para conversarmos melhor. Juntos, podemos iniciar uma jornada terapêutica que faça sentido para você. Estou à disposição para oferecer o apoio que você precisa. Conte comigo!'
    },
    features: [
      {
        title: 'Formado em Psicologia',
        description: ' Formado pelo Centro Universitário Frassinetti do Recife (Unifafire)'
      },
      {
        title: 'Experiência em atendimento online e presencial',
        description: 'Flexibilidade para atender suas necessidades, com a mesma qualidade e profissionalismo.'
      }
    ],
    services: [
      {
        title: 'Por que fazer Terapia?',
        description: 'Durante nossa vida nos deparamos com assuntos, temas, pessoas ou situações que nos causam desconforto, e quando você sentir que não está dando conta sozinho, eu estarei lá e você poderá contar comigo para que juntos possamos buscar aprender a lidar de uma maneira mais confortável.'
      },
      {
        title: 'Quais temas de terapia você atende? Depressão? Ansiedade? Luto?',
        description: 'Como psicólogo, estou aberto a atender esses e outros temas, independentemente de sua complexidade. Meu compromisso é oferecer suporte a cada pessoa da melhor forma possível, acolhendo suas necessidades com dedicação e empatia.'
      },
      {
        title: 'Qual o preço da sua sessão?',
        description: 'A primeira sessão é gratuita, para que possamos nos conhecer para que juntos possamos combinar um valor confortável para ambas as partes.'
      },
      {
        title: 'Em quanto tempo eu devo ter alta?',
        description: 'Então, não existe um tempo predeterminado para alta terapêutica, pois cada processo é um único, individual e incomparável. Além disso o protagonista desse processo é você, então só você pode decidir o momento certo para ter sua alta.'
      },
      {
        title: 'Todos os Psicólogos seguem essas premissas aqui dispostas?',
        description: 'Na verdade, não. Cada psicólogo enxerga e estuda o mundo de maneira única, geralmente a partir de uma abordagem específica. Sendo assim, é possível que outros profissionais que também seguem a Abordagem Centrada na Pessoa (ACP) se identifiquem com alguns dos pontos apresentados aqui.'
      },
      {
        title: 'Quais assuntos eu posso conversar com meu psicólogo?',
        description: 'Dentro do setting terapêutico você terá total liberdade para abordar qualquer assunto que seja do seu interesse, e que possa lhe ajudar na sua caminhada. '
      }
    ],
    contact: {
      title: 'Entre em Contato',
      address: 'Empresarial Palmira I - Av. Conde da Boa Vista, 1410 - Sala 402 - Boa Vista, Recife - PE, 50060-001',
      email: 'psi.gabrieldecarli@gmail.com',
      whatsapp: '+55 (81) 98885-6777',
      instagram: '@psi.gabrieldecarli'
    }
  },
  sobre: {
    profile: {
      title: 'Gabriel de Carli',
      subtitle: 'Psicólogo Clínico - CRP 02/29417',
    },
    sections: {
      formacao: {
        title: 'Formação e Experiência',
        content: 'Formado em Psicologia pelo Centro Universitário Frassinetti do Recife (UNIFAFIRE), com especialização em Psicologia Clínica e Abordagem Centrada na Pessoa (ACP). Dedico-me a proporcionar um ambiente seguro e acolhedor para o desenvolvimento pessoal e bem-estar emocional dos meus pacientes. Mantenho constante atualização através de cursos e supervisões para oferecer o melhor atendimento possível.'
      },
      abordagem: {
        title: 'Abordagem Terapêutica',
        content: 'Trabalho com a Abordagem Centrada na Pessoa (ACP), desenvolvida por Carl Rogers. Esta abordagem se baseia na crença de que cada pessoa tem dentro de si os recursos necessários para seu crescimento e desenvolvimento pessoal. Como terapeuta, meu papel é criar um ambiente seguro e acolhedor, livre de julgamentos, onde você possa explorar seus pensamentos e sentimentos livremente.'
      },
      areas: {
        title: 'Áreas de Atuação',
        items: [
          'Ansiedade',
          'Depressão',
          'Autoestima',
          'Relacionamentos',
          'Desenvolvimento Pessoal',
          'Questões Familiares',
          'Luto',
          'Estresse',
          'Traumas',
          'Fobias'
        ]
      }
    },
    contact: {
      address: 'Empresarial Palmira I - Av. Conde da Boa Vista, 1410 - Sala 402 - Boa Vista, Recife - PE, 50060-001',
      email: 'psi.gabrieldecarli@gmail.com',
      whatsapp: '+55 (81) 98885-6777',
      instagram: '@psi.gabrieldecarli'
    }
  }
};